<div class="error-header">
  <img src="assets/images/MatrixCare_Logo.svg" class="mxc-logo" alt="MatrixCare Logo" />
</div>

<div class="row" style="margin-top:70px;">
  <div class="col" style="text-align:right">
    <img src="assets/images/worker.png" style="width:320px;margin-right:20px" />
  </div>
  <div class="col" style="  margin-left:20px; ">
    <div class="card-img-overlay d-flex justify-content-center  flex-column">
      <div style="font-size:40px; font-weight:bold">Access denied.</div><br />
      <div style="font-size:20px">
        <div>Error Code 403</div><br />
        <div>Sorry, But you are not authorized to access this page.</div><br />
        <div>We apologize for any inconvenience caused.</div>
        <div>You can go back to the <a href="javascript:void()" (click)="goBack()">previous page</a></div>
      </div>
    </div>
  </div>
</div>


